export default __webpack_public_path__ + "static/media/Ubuntu-Regular.3525fd90.woff2";